export default __webpack_public_path__ + "launch.ae453c47.svg";